const lithiumIonBatteriesData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133794/assets/data-reports/price-assessments/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_3fc329a4-f738-4b47-ae32-d252c3e69aef_hiktbp.png',
  priceAssessmentsBrochureFile: {
    EnvKey: 'lithiumIonBatteriesPriceAssessmentsMethodologyId',
    category: 'methodology-price-assessments',
    file_name:
      'Benchmark-Lithium-Ion-Batteries-Cells-Price-Assessment-Methodology.pdf',
  },
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureBatteryDatabaseFilePdfID',
    file_name: 'Lithium ion Batteries Forecast Brochure.pdf',
    category: 'public-documents',
  },
  marketAssessmentsBrochureFile: {
    category: 'methodology-market-assessments',
    file_name: 'Benchmark-Gigafactory-Assessment-Methodology.pdf',
    EnvKey: 'gigafactoriesPriceAssessmentsMethodologyId',
  },
  banner: {
    title:
      'Our quarterly service includes a comprehensive battery cell supply model:',
    descriptions: [
      {
        items: [
          '<strong>Plant-by-plant:</strong> MWh production data for every global battery cell facility through to 2040',
          '<strong>Cathode chemistry</strong> and cell format information',
          '<strong>EV vs Portable:</strong> see where production capacity is focussed',
          '<strong>Expansions:</strong> track all new battery plant developments and investments',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto/v1719515708/assets/market/lithium-ion-batteries/data-and-reports/one-image_ycrp5z.png?_i=AA',
        alt: 'Lithium ion Batteries Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto/v1719515801/assets/market/lithium-ion-batteries/data-and-reports/two-images_eszhdh.png?_i=AA',
        alt: 'Lithium ion Batteries Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto/v1719515902/assets/market/lithium-ion-batteries/data-and-reports/three-image_airuqe.png?_i=AA',
        alt: 'Lithium ion Batteries Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_700,c_fill/v1719516128/assets/market/lithium-ion-batteries/data-and-reports/four-image_m5ynuy.png?_i=AA',
      title:
        'Our full picture understanding of Lithium ion Batteries is most prevalent in our bottom-up cost curve analysis.',
      descriptions: [
        {
          subtitle:
            'The Battery Database features detailed data and analysis for every lithium ion application:',
          items: [
            '<strong>Annualised MWh-level demand</strong> data for transportation (EV), stationary storage (ESS) and portable applications, from 2015-2040',
            '<strong>Demand drivers:</strong> A full breakdown of each sub-segment of demand - from BEVs and PHEVs, to smartphones and tablets',
            '<strong>Technology profile:</strong> explore the anode and cathode trends for each end-market',
            '<strong>Regional perspective:</strong> See where in the world battery demand originates, and what countries will lead the clean energy transition',
          ],
        },
        {
          subtitle:
            'Review how battery costs vary between technologies, manufacturing scale, and raw material inputs:',
          items: [
            '<strong>Cost breakdown:</strong> analysis of the cost structure for battery cells across different chemistries',
            '<strong>Bill of materials:</strong> monitor the impact of material costs',
            '<strong>A fully customisable</strong> battery cost model profiling costs across different plants, regions and technology profiles',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,c_fill,q_auto,g_auto,h_700/v1719517376/assets/market/lithium-ion-batteries/data-and-reports/five-image_qbmewv.png?_i=AA',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Battery Database:',
      descriptions: [
        {
          items: [
            '<strong>Online</strong> accessible downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in excel and pdf format',
            '<strong>Implement Your Ideas</strong>: Each file is fully customisable so you can input your own assumptions',
          ],
        },
      ],
    },
  },
}
export default lithiumIonBatteriesData
